import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as PersonAddressActions from '../_actions/personAddress';
import { PersonAddress } from '../_models';

export interface PersonAddressState extends EntityState<PersonAddress> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<PersonAddress> = createEntityAdapter<PersonAddress>();

const initialState: PersonAddressState = adapter.getInitialState({
  loading: false,
  error: null,
});

const personAddressReducer = createReducer(
  initialState,

  on(PersonAddressActions.loadPersonAddresses, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(PersonAddressActions.loadPersonAddressesSuccess, (state, { personAddresses }) =>
    adapter.setAll(personAddresses, { ...state, loading: false })
  ),

  on(PersonAddressActions.loadPersonAddressesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(PersonAddressActions.addPersonAddressSuccess, (state, { personAddress }) =>
    adapter.addOne(personAddress, state)
  ),

  on(PersonAddressActions.updatePersonAddressSuccess, (state, { personAddress }) =>
    adapter.upsertOne(personAddress, state)
  ),

  on(PersonAddressActions.deletePersonAddressSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    PersonAddressActions.addPersonAddressFailure,
    PersonAddressActions.updatePersonAddressFailure,
    PersonAddressActions.deletePersonAddressFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: PersonAddressState | undefined, action: Action) {
  return personAddressReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
